import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { autocomplete, getSuggestedItem } from "../../actions/ui/autocomplete";
import AutocompleteInput from "../AutocompleteInput";

class LicenseSearch extends Component {
  static propTypes = {
    search: PropTypes.object.isRequired,
    onSearch: PropTypes.func.isRequired,
    // Injected by React-Redux
    userGroup: PropTypes.string.isRequired,
    autocomplete: PropTypes.func.isRequired,
    getSuggestedItem: PropTypes.func.isRequired
  };

  search = event => {
    event.preventDefault(); // this should be first line in order to prevent the form from being submitted if there is an error
    const ip = this.ipField.value.trim(),
      secondaryIp = this.secondaryIpField.value.trim(),
      servers = parseInt(this.serversField.value.trim(), 10),
      build = this.buildField ? this.buildField.value.trim() : "",
      params = {};
    if (ip) {
      params.ip = ip;
    }
    if (secondaryIp) {
      params.secondaryIp = secondaryIp;
    }
    if (servers) {
      params.servers = servers;
    }
    if (this.customer) {
      params.customer = this.customer;
    }
    if (build) {
      params.build = build;
    }
    this.props.onSearch(params);
    return false;
  };

  clear = () => {
    this.ipField.value = "";
    this.secondaryIpField.value = "";
    this.serversField.value = "";
    if (this.buildField) {
      this.buildField.value = "";
    }
    this.props.onSearch({});
  };

  autocomplete = (search, count) => {
    this.props.autocomplete(
      "customer",
      { company: search, active: true },
      {},
      count
    );
  };

  render = () => {
    const { search, userGroup, getSuggestedItem } = this.props,
      isStaff = "admin" === userGroup || "staff" === userGroup;
    return (
      <form className="ui form" onSubmit={this.search}>
        <div className={isStaff ? "five fields" : "three fields"}>
          <div className="field">
            <label htmlFor="ip">IP</label>
            <input
              type="text"
              tabIndex="10"
              name="ip"
              id="ip"
              placeholder="IP Address"
              autoComplete="off"
              autoFocus={true}
              defaultValue={search.ip}
              ref={input => (this.ipField = input)}
            />
          </div>
          <div className="field">
            <label htmlFor="secondaryIp">Secondary IP</label>
            <input
              type="text"
              tabIndex="20"
              name="secondaryIp"
              id="secondaryIp"
              placeholder="IP Address"
              autoComplete="off"
              defaultValue={search.secondaryIp}
              ref={input => (this.secondaryIpField = input)}
            />
          </div>
          <div className="field">
            <label htmlFor="servers">Servers</label>
            <input
              type="number"
              tabIndex="30"
              name="servers"
              id="servers"
              placeholder="Number of servers"
              autoComplete="off"
              defaultValue={search.servers}
              ref={input => (this.serversField = input)}
            />
          </div>
          {isStaff && (
            <div className="field">
              <AutocompleteInput
                title="Customer"
                count={3}
                tabIndex={40}
                getSuggestedItem={id => {
                  getSuggestedItem("customer", id, { _id: 1, company: 1 });
                }}
                searchItem={this.autocomplete}
                required={true}
                getName={customer => customer.company}
                selectItem={id => {
                  this.customer = id;
                }}
              />
            </div>
          )}
          {isStaff && (
            <div className="field">
              <label htmlFor="id">Build ID</label>
              <input
                type="text"
                tabIndex="50"
                name="build"
                id="build"
                placeholder="Exact ID"
                defaultValue={search.build}
                ref={input => (this.buildField = input)}
              />
            </div>
          )}
        </div>
        <button
          id="clear"
          tabIndex="110"
          className="ui negative button"
          type="button"
          onClick={this.clear}
        >
          Clear
        </button>
        <button
          id="search"
          tabIndex="100"
          className="ui primary button"
          type="submit"
        >
          Search
        </button>
      </form>
    );
  };
}

const mapStateToProps = state => ({
  userGroup: state.auth.user.group
});

export default connect(
  mapStateToProps,
  {
    autocomplete,
    getSuggestedItem
  }
)(LicenseSearch);
